var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/runtime.ts
var BASE_PATH = "http://localhost/external_user/v1.0".replace(/\/+$/, "");
var Configuration = class {
  constructor(configuration = {}) {
    this.configuration = configuration;
  }
  set config(configuration) {
    this.configuration = configuration;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || querystring;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const apiKey = this.configuration.apiKey;
    if (apiKey) {
      return typeof apiKey === "function" ? apiKey : () => apiKey;
    }
    return void 0;
  }
  get accessToken() {
    const accessToken = this.configuration.accessToken;
    if (accessToken) {
      return typeof accessToken === "function" ? accessToken : () => __async(this, null, function* () {
        return accessToken;
      });
    }
    return void 0;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
};
var DefaultConfig = new Configuration();
var _BaseAPI = class _BaseAPI {
  constructor(configuration = DefaultConfig) {
    this.configuration = configuration;
    this.fetchApi = (url, init) => __async(this, null, function* () {
      let fetchParams = { url, init };
      for (const middleware of this.middleware) {
        if (middleware.pre) {
          fetchParams = (yield middleware.pre(__spreadValues({
            fetch: this.fetchApi
          }, fetchParams))) || fetchParams;
        }
      }
      let response = void 0;
      try {
        response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
      } catch (e) {
        for (const middleware of this.middleware) {
          if (middleware.onError) {
            response = (yield middleware.onError({
              fetch: this.fetchApi,
              url: fetchParams.url,
              init: fetchParams.init,
              error: e,
              response: response ? response.clone() : void 0
            })) || response;
          }
        }
        if (response === void 0) {
          if (e instanceof Error) {
            throw new FetchError(e, "The request failed and the interceptors did not return an alternative response");
          } else {
            throw e;
          }
        }
      }
      for (const middleware of this.middleware) {
        if (middleware.post) {
          response = (yield middleware.post({
            fetch: this.fetchApi,
            url: fetchParams.url,
            init: fetchParams.init,
            response: response.clone()
          })) || response;
        }
      }
      return response;
    });
    this.middleware = configuration.middleware;
  }
  withMiddleware(...middlewares) {
    const next = this.clone();
    next.middleware = next.middleware.concat(...middlewares);
    return next;
  }
  withPreMiddleware(...preMiddlewares) {
    const middlewares = preMiddlewares.map((pre) => ({ pre }));
    return this.withMiddleware(...middlewares);
  }
  withPostMiddleware(...postMiddlewares) {
    const middlewares = postMiddlewares.map((post) => ({ post }));
    return this.withMiddleware(...middlewares);
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    if (!mime) {
      return false;
    }
    return _BaseAPI.jsonRegex.test(mime);
  }
  request(context, initOverrides) {
    return __async(this, null, function* () {
      const { url, init } = yield this.createFetchParams(context, initOverrides);
      const response = yield this.fetchApi(url, init);
      if (response && (response.status >= 200 && response.status < 300)) {
        return response;
      }
      throw new ResponseError(response, "Response returned an error code");
    });
  }
  createFetchParams(context, initOverrides) {
    return __async(this, null, function* () {
      let url = this.configuration.basePath + context.path;
      if (context.query !== void 0 && Object.keys(context.query).length !== 0) {
        url += "?" + this.configuration.queryParamsStringify(context.query);
      }
      const headers = Object.assign({}, this.configuration.headers, context.headers);
      Object.keys(headers).forEach((key) => headers[key] === void 0 ? delete headers[key] : {});
      const initOverrideFn = typeof initOverrides === "function" ? initOverrides : () => __async(this, null, function* () {
        return initOverrides;
      });
      const initParams = {
        method: context.method,
        headers,
        body: context.body,
        credentials: this.configuration.credentials
      };
      const overriddenInit = __spreadValues(__spreadValues({}, initParams), yield initOverrideFn({
        init: initParams,
        context
      }));
      let body;
      if (isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || isBlob(overriddenInit.body)) {
        body = overriddenInit.body;
      } else if (this.isJsonMime(headers["Content-Type"])) {
        body = JSON.stringify(overriddenInit.body);
      } else {
        body = overriddenInit.body;
      }
      const init = __spreadProps(__spreadValues({}, overriddenInit), {
        body
      });
      return { url, init };
    });
  }
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const constructor = this.constructor;
    const next = new constructor(this.configuration);
    next.middleware = this.middleware.slice();
    return next;
  }
};
_BaseAPI.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
var BaseAPI = _BaseAPI;
function isBlob(value) {
  return typeof Blob !== "undefined" && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
var ResponseError = class extends Error {
  constructor(response, msg) {
    super(msg);
    this.response = response;
    this.name = "ResponseError";
  }
};
var FetchError = class extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
    this.name = "FetchError";
  }
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = "RequiredError";
  }
};
var COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function exists(json, key) {
  const value = json[key];
  return value !== null && value !== void 0;
}
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => querystringSingleKey(key, params[key], prefix)).filter((part) => part.length > 0).join("&");
}
function querystringSingleKey(key, value, keyPrefix = "") {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
  if (value instanceof Array) {
    const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
    return `${encodeURIComponent(fullKey)}=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
  return Object.keys(data).reduce(
    (acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: fn(data[key]) }),
    {}
  );
}
function canConsumeForm(consumes) {
  for (const consume of consumes) {
    if ("multipart/form-data" === consume.contentType) {
      return true;
    }
  }
  return false;
}
var JSONApiResponse = class {
  constructor(raw, transformer = (jsonValue) => jsonValue) {
    this.raw = raw;
    this.transformer = transformer;
  }
  value() {
    return __async(this, null, function* () {
      return this.transformer(yield this.raw.json());
    });
  }
};
var VoidApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return void 0;
    });
  }
};
var BlobApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return yield this.raw.blob();
    });
  }
};
var TextApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return yield this.raw.text();
    });
  }
};

// src/models/Luggage.ts
function instanceOfLuggage(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function LuggageFromJSON(json) {
  return LuggageFromJSONTyped(json, false);
}
function LuggageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function LuggageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/SeatSelection.ts
function instanceOfSeatSelection(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function SeatSelectionFromJSON(json) {
  return SeatSelectionFromJSONTyped(json, false);
}
function SeatSelectionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function SeatSelectionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/TravelInsurance.ts
function instanceOfTravelInsurance(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function TravelInsuranceFromJSON(json) {
  return TravelInsuranceFromJSONTyped(json, false);
}
function TravelInsuranceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function TravelInsuranceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/Unclassified.ts
function instanceOfUnclassified(value) {
  let isInstance = true;
  isInstance = isInstance && "total_price" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function UnclassifiedFromJSON(json) {
  return UnclassifiedFromJSONTyped(json, false);
}
function UnclassifiedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total_price": json["total_price"],
    "type": json["type"]
  };
}
function UnclassifiedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total_price": value.total_price,
    "type": value.type
  };
}

// src/models/Ancillary.ts
function AncillaryFromJSON(json) {
  return AncillaryFromJSONTyped(json, false);
}
function AncillaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "luggage":
      return __spreadProps(__spreadValues({}, LuggageFromJSONTyped(json, true)), { type: "luggage" });
    case "seat_selection":
      return __spreadProps(__spreadValues({}, SeatSelectionFromJSONTyped(json, true)), { type: "seat_selection" });
    case "travel_insurance":
      return __spreadProps(__spreadValues({}, TravelInsuranceFromJSONTyped(json, true)), { type: "travel_insurance" });
    case "unclassified":
      return __spreadProps(__spreadValues({}, UnclassifiedFromJSONTyped(json, true)), { type: "unclassified" });
    default:
      throw new Error(`No variant of Ancillary exists with 'type=${json["type"]}'`);
  }
}
function AncillaryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "luggage":
      return LuggageToJSON(value);
    case "seat_selection":
      return SeatSelectionToJSON(value);
    case "travel_insurance":
      return TravelInsuranceToJSON(value);
    case "unclassified":
      return UnclassifiedToJSON(value);
    default:
      throw new Error(`No variant of Ancillary exists with 'type=${value["type"]}'`);
  }
}

// src/models/ModelError.ts
function instanceOfModelError(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ModelErrorFromJSON(json) {
  return ModelErrorFromJSONTyped(json, false);
}
function ModelErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ModelErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/BadRequest.ts
function instanceOfBadRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "errors" in value;
  return isInstance;
}
function BadRequestFromJSON(json) {
  return BadRequestFromJSONTyped(json, false);
}
function BadRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "errors": json["errors"].map(ModelErrorFromJSON)
  };
}
function BadRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "errors": value.errors.map(ModelErrorToJSON)
  };
}

// src/models/BookingCancellationNotFound.ts
function instanceOfBookingCancellationNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function BookingCancellationNotFoundFromJSON(json) {
  return BookingCancellationNotFoundFromJSONTyped(json, false);
}
function BookingCancellationNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function BookingCancellationNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CancelBookingFailed.ts
function instanceOfCancelBookingFailed(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function CancelBookingFailedFromJSON(json) {
  return CancelBookingFailedFromJSONTyped(json, false);
}
function CancelBookingFailedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function CancelBookingFailedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CancelBookingFailure.ts
function instanceOfCancelBookingFailure(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function CancelBookingFailureFromJSON(json) {
  return CancelBookingFailureFromJSONTyped(json, false);
}
function CancelBookingFailureFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function CancelBookingFailureToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CancellationAlreadyProcessed.ts
function instanceOfCancellationAlreadyProcessed(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function CancellationAlreadyProcessedFromJSON(json) {
  return CancellationAlreadyProcessedFromJSONTyped(json, false);
}
function CancellationAlreadyProcessedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function CancellationAlreadyProcessedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CancellationMethod.ts
var CancellationMethod = {
  Sync: "sync",
  Async: "async"
};
function CancellationMethodFromJSON(json) {
  return CancellationMethodFromJSONTyped(json, false);
}
function CancellationMethodFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CancellationMethodToJSON(value) {
  return value;
}

// src/models/CancellationSource.ts
var CancellationSource = {
  Hopper: "hopper",
  Partner: "partner"
};
function CancellationSourceFromJSON(json) {
  return CancellationSourceFromJSONTyped(json, false);
}
function CancellationSourceFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CancellationSourceToJSON(value) {
  return value;
}

// src/models/Completed.ts
function instanceOfCompleted(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function CompletedFromJSON(json) {
  return CompletedFromJSONTyped(json, false);
}
function CompletedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function CompletedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/Failed.ts
function instanceOfFailed(value) {
  let isInstance = true;
  isInstance = isInstance && "reason" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function FailedFromJSON(json) {
  return FailedFromJSONTyped(json, false);
}
function FailedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "reason": json["reason"],
    "type": json["type"]
  };
}
function FailedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reason": value.reason,
    "type": value.type
  };
}

// src/models/Processing.ts
function instanceOfProcessing(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function ProcessingFromJSON(json) {
  return ProcessingFromJSONTyped(json, false);
}
function ProcessingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function ProcessingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/PartnerBookingCancellationStatus.ts
function PartnerBookingCancellationStatusFromJSON(json) {
  return PartnerBookingCancellationStatusFromJSONTyped(json, false);
}
function PartnerBookingCancellationStatusFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "completed":
      return __spreadProps(__spreadValues({}, CompletedFromJSONTyped(json, true)), { type: "completed" });
    case "failed":
      return __spreadProps(__spreadValues({}, FailedFromJSONTyped(json, true)), { type: "failed" });
    case "processing":
      return __spreadProps(__spreadValues({}, ProcessingFromJSONTyped(json, true)), { type: "processing" });
    default:
      throw new Error(`No variant of PartnerBookingCancellationStatus exists with 'type=${json["type"]}'`);
  }
}
function PartnerBookingCancellationStatusToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "completed":
      return CompletedToJSON(value);
    case "failed":
      return FailedToJSON(value);
    case "processing":
      return ProcessingToJSON(value);
    default:
      throw new Error(`No variant of PartnerBookingCancellationStatus exists with 'type=${value["type"]}'`);
  }
}

// src/models/CfarPartnerBookingCancellation.ts
function instanceOfCfarPartnerBookingCancellation(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "exercise_id" in value;
  isInstance = isInstance && "requested_date_time" in value;
  isInstance = isInstance && "method" in value;
  isInstance = isInstance && "status" in value;
  return isInstance;
}
function CfarPartnerBookingCancellationFromJSON(json) {
  return CfarPartnerBookingCancellationFromJSONTyped(json, false);
}
function CfarPartnerBookingCancellationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "exercise_id": json["exercise_id"],
    "requested_date_time": new Date(json["requested_date_time"]),
    "completed_date_time": !exists(json, "completed_date_time") ? void 0 : new Date(json["completed_date_time"]),
    "method": CancellationMethodFromJSON(json["method"]),
    "source": !exists(json, "source") ? void 0 : CancellationSourceFromJSON(json["source"]),
    "status": PartnerBookingCancellationStatusFromJSON(json["status"])
  };
}
function CfarPartnerBookingCancellationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "exercise_id": value.exercise_id,
    "requested_date_time": value.requested_date_time.toISOString(),
    "completed_date_time": value.completed_date_time === void 0 ? void 0 : value.completed_date_time.toISOString(),
    "method": CancellationMethodToJSON(value.method),
    "source": CancellationSourceToJSON(value.source),
    "status": PartnerBookingCancellationStatusToJSON(value.status)
  };
}

// src/models/CfarExercise.ts
function instanceOfCfarExercise(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "ext_attributes" in value;
  return isInstance;
}
function CfarExerciseFromJSON(json) {
  return CfarExerciseFromJSONTyped(json, false);
}
function CfarExerciseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "contract_id": json["contract_id"],
    "completed_date_time": !exists(json, "completed_date_time") ? void 0 : new Date(json["completed_date_time"]),
    "partner_booking_cancellation": !exists(json, "partner_booking_cancellation") ? void 0 : CfarPartnerBookingCancellationFromJSON(json["partner_booking_cancellation"]),
    "exchange_rate": !exists(json, "exchange_rate") ? void 0 : json["exchange_rate"],
    "partner_refund_share": !exists(json, "partner_refund_share") ? void 0 : json["partner_refund_share"],
    "airline_refund_share": !exists(json, "airline_refund_share") ? void 0 : json["airline_refund_share"],
    "currency": !exists(json, "currency") ? void 0 : json["currency"],
    "ext_attributes": json["ext_attributes"]
  };
}
function CfarExerciseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "contract_id": value.contract_id,
    "completed_date_time": value.completed_date_time === void 0 ? void 0 : value.completed_date_time.toISOString(),
    "partner_booking_cancellation": CfarPartnerBookingCancellationToJSON(value.partner_booking_cancellation),
    "exchange_rate": value.exchange_rate,
    "partner_refund_share": value.partner_refund_share,
    "airline_refund_share": value.airline_refund_share,
    "currency": value.currency,
    "ext_attributes": value.ext_attributes
  };
}

// src/models/FareClass.ts
var FareClass = {
  BasicEconomy: "basic_economy",
  Economy: "economy",
  PremiumEconomy: "premium_economy",
  Business: "business",
  First: "first"
};
function FareClassFromJSON(json) {
  return FareClassFromJSONTyped(json, false);
}
function FareClassFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function FareClassToJSON(value) {
  return value;
}

// src/models/CfarFareSliceSegment.ts
function instanceOfCfarFareSliceSegment(value) {
  let isInstance = true;
  isInstance = isInstance && "origin_airport" in value;
  isInstance = isInstance && "destination_airport" in value;
  isInstance = isInstance && "departure_date_time" in value;
  isInstance = isInstance && "arrival_date_time" in value;
  isInstance = isInstance && "flight_number" in value;
  isInstance = isInstance && "validating_carrier_code" in value;
  isInstance = isInstance && "operating_carrier_code" in value;
  isInstance = isInstance && "marketing_carrier_code" in value;
  isInstance = isInstance && "fare_class" in value;
  isInstance = isInstance && "fare_basis" in value;
  return isInstance;
}
function CfarFareSliceSegmentFromJSON(json) {
  return CfarFareSliceSegmentFromJSONTyped(json, false);
}
function CfarFareSliceSegmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "origin_airport": json["origin_airport"],
    "destination_airport": json["destination_airport"],
    "departure_date_time": json["departure_date_time"],
    "arrival_date_time": json["arrival_date_time"],
    "flight_number": json["flight_number"],
    "validating_carrier_code": json["validating_carrier_code"],
    "operating_carrier_code": json["operating_carrier_code"],
    "marketing_carrier_code": json["marketing_carrier_code"],
    "fare_class": FareClassFromJSON(json["fare_class"]),
    "fare_basis": json["fare_basis"]
  };
}
function CfarFareSliceSegmentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "origin_airport": value.origin_airport,
    "destination_airport": value.destination_airport,
    "departure_date_time": value.departure_date_time,
    "arrival_date_time": value.arrival_date_time,
    "flight_number": value.flight_number,
    "validating_carrier_code": value.validating_carrier_code,
    "operating_carrier_code": value.operating_carrier_code,
    "marketing_carrier_code": value.marketing_carrier_code,
    "fare_class": FareClassToJSON(value.fare_class),
    "fare_basis": value.fare_basis
  };
}

// src/models/CfarFareSlice.ts
function instanceOfCfarFareSlice(value) {
  let isInstance = true;
  isInstance = isInstance && "segments" in value;
  return isInstance;
}
function CfarFareSliceFromJSON(json) {
  return CfarFareSliceFromJSONTyped(json, false);
}
function CfarFareSliceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "segments": json["segments"].map(CfarFareSliceSegmentFromJSON)
  };
}
function CfarFareSliceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "segments": value.segments.map(CfarFareSliceSegmentToJSON)
  };
}

// src/models/PassengerType.ts
var PassengerType = {
  Adult: "adult",
  Child: "child",
  SeatedInfant: "seated_infant",
  LapInfant: "lap_infant",
  Unknown: "unknown"
};
function PassengerTypeFromJSON(json) {
  return PassengerTypeFromJSONTyped(json, false);
}
function PassengerTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function PassengerTypeToJSON(value) {
  return value;
}

// src/models/Passenger.ts
function instanceOfPassenger(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "individual_price" in value;
  return isInstance;
}
function PassengerFromJSON(json) {
  return PassengerFromJSONTyped(json, false);
}
function PassengerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": PassengerTypeFromJSON(json["type"]),
    "name": !exists(json, "name") ? void 0 : json["name"],
    "individual_price": json["individual_price"]
  };
}
function PassengerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": PassengerTypeToJSON(value.type),
    "name": value.name,
    "individual_price": value.individual_price
  };
}

// src/models/CfarFare.ts
function instanceOfCfarFare(value) {
  let isInstance = true;
  isInstance = isInstance && "passengers" in value;
  isInstance = isInstance && "currency" in value;
  isInstance = isInstance && "slices" in value;
  return isInstance;
}
function CfarFareFromJSON(json) {
  return CfarFareFromJSONTyped(json, false);
}
function CfarFareFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "passengers": json["passengers"].map(PassengerFromJSON),
    "currency": json["currency"],
    "slices": json["slices"].map(CfarFareSliceFromJSON),
    "ancillaries": !exists(json, "ancillaries") ? void 0 : json["ancillaries"].map(AncillaryFromJSON)
  };
}
function CfarFareToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "passengers": value.passengers.map(PassengerToJSON),
    "currency": value.currency,
    "slices": value.slices.map(CfarFareSliceToJSON),
    "ancillaries": value.ancillaries === void 0 ? void 0 : value.ancillaries.map(AncillaryToJSON)
  };
}

// src/models/CfarPurchaseOption.ts
function instanceOfCfarPurchaseOption(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "premium_percentage" in value;
  isInstance = isInstance && "premium_per_passenger" in value;
  isInstance = isInstance && "total_premium" in value;
  isInstance = isInstance && "coverage_percentage" in value;
  isInstance = isInstance && "coverage_per_passenger" in value;
  isInstance = isInstance && "total_coverage" in value;
  return isInstance;
}
function CfarPurchaseOptionFromJSON(json) {
  return CfarPurchaseOptionFromJSONTyped(json, false);
}
function CfarPurchaseOptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "premium_percentage": json["premium_percentage"],
    "premium_per_passenger": json["premium_per_passenger"],
    "total_premium": json["total_premium"],
    "coverage_percentage": json["coverage_percentage"],
    "coverage_per_passenger": json["coverage_per_passenger"],
    "total_coverage": json["total_coverage"]
  };
}
function CfarPurchaseOptionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "premium_percentage": value.premium_percentage,
    "premium_per_passenger": value.premium_per_passenger,
    "total_premium": value.total_premium,
    "coverage_percentage": value.coverage_percentage,
    "coverage_per_passenger": value.coverage_per_passenger,
    "total_coverage": value.total_coverage
  };
}

// src/models/CfarOffer.ts
function instanceOfCfarOffer(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "purchase_options" in value;
  isInstance = isInstance && "currency" in value;
  isInstance = isInstance && "to_usd_exchange_rate" in value;
  isInstance = isInstance && "contract_expiry" in value;
  isInstance = isInstance && "created_date_time" in value;
  return isInstance;
}
function CfarOfferFromJSON(json) {
  return CfarOfferFromJSONTyped(json, false);
}
function CfarOfferFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "purchase_options": json["purchase_options"].map(CfarPurchaseOptionFromJSON),
    "currency": json["currency"],
    "to_usd_exchange_rate": json["to_usd_exchange_rate"],
    "contract_expiry": new Date(json["contract_expiry"]),
    "created_date_time": new Date(json["created_date_time"]),
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"]
  };
}
function CfarOfferToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "purchase_options": value.purchase_options.map(CfarPurchaseOptionToJSON),
    "currency": value.currency,
    "to_usd_exchange_rate": value.to_usd_exchange_rate,
    "contract_expiry": value.contract_expiry.toISOString(),
    "created_date_time": value.created_date_time.toISOString(),
    "ext_attributes": value.ext_attributes
  };
}

// src/models/CfarPurchaseQuote.ts
function instanceOfCfarPurchaseQuote(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "offer" in value;
  isInstance = isInstance && "purchase_option_id" in value;
  isInstance = isInstance && "premium_per_passenger" in value;
  isInstance = isInstance && "total_premium" in value;
  isInstance = isInstance && "coverage_per_passenger" in value;
  isInstance = isInstance && "total_coverage" in value;
  isInstance = isInstance && "fare" in value;
  return isInstance;
}
function CfarPurchaseQuoteFromJSON(json) {
  return CfarPurchaseQuoteFromJSONTyped(json, false);
}
function CfarPurchaseQuoteFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "offer": CfarOfferFromJSON(json["offer"]),
    "purchase_option_id": json["purchase_option_id"],
    "premium_per_passenger": json["premium_per_passenger"],
    "total_premium": json["total_premium"],
    "coverage_per_passenger": json["coverage_per_passenger"],
    "total_coverage": json["total_coverage"],
    "fare": CfarFareFromJSON(json["fare"])
  };
}
function CfarPurchaseQuoteToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "offer": CfarOfferToJSON(value.offer),
    "purchase_option_id": value.purchase_option_id,
    "premium_per_passenger": value.premium_per_passenger,
    "total_premium": value.total_premium,
    "coverage_per_passenger": value.coverage_per_passenger,
    "total_coverage": value.total_coverage,
    "fare": CfarFareToJSON(value.fare)
  };
}

// src/models/Other.ts
function instanceOfOther(value) {
  let isInstance = true;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function OtherFromJSON(json) {
  return OtherFromJSONTyped(json, false);
}
function OtherFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "description": json["description"],
    "type": json["type"]
  };
}
function OtherToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "description": value.description,
    "type": value.type
  };
}

// src/models/TicketingFailure.ts
function instanceOfTicketingFailure(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function TicketingFailureFromJSON(json) {
  return TicketingFailureFromJSONTyped(json, false);
}
function TicketingFailureFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function TicketingFailureToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/VoidWindow.ts
function instanceOfVoidWindow(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function VoidWindowFromJSON(json) {
  return VoidWindowFromJSONTyped(json, false);
}
function VoidWindowFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function VoidWindowToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/models/CfarRefundReason.ts
function CfarRefundReasonFromJSON(json) {
  return CfarRefundReasonFromJSONTyped(json, false);
}
function CfarRefundReasonFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "other":
      return __spreadProps(__spreadValues({}, OtherFromJSONTyped(json, true)), { type: "other" });
    case "ticketing_failure":
      return __spreadProps(__spreadValues({}, TicketingFailureFromJSONTyped(json, true)), { type: "ticketing_failure" });
    case "void_window":
      return __spreadProps(__spreadValues({}, VoidWindowFromJSONTyped(json, true)), { type: "void_window" });
    default:
      throw new Error(`No variant of CfarRefundReason exists with 'type=${json["type"]}'`);
  }
}
function CfarRefundReasonToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "other":
      return OtherToJSON(value);
    case "ticketing_failure":
      return TicketingFailureToJSON(value);
    case "void_window":
      return VoidWindowToJSON(value);
    default:
      throw new Error(`No variant of CfarRefundReason exists with 'type=${value["type"]}'`);
  }
}

// src/models/CfarRefund.ts
function instanceOfCfarRefund(value) {
  let isInstance = true;
  isInstance = isInstance && "reason" in value;
  isInstance = isInstance && "refunded_date_time" in value;
  return isInstance;
}
function CfarRefundFromJSON(json) {
  return CfarRefundFromJSONTyped(json, false);
}
function CfarRefundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "reason": CfarRefundReasonFromJSON(json["reason"]),
    "refunded_date_time": new Date(json["refunded_date_time"])
  };
}
function CfarRefundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reason": CfarRefundReasonToJSON(value.reason),
    "refunded_date_time": value.refunded_date_time.toISOString()
  };
}

// src/models/State.ts
var State = {
  Active: "active",
  ExerciseFailed: "exercise_failed",
  ExerciseInitiated: "exercise_initiated",
  ExerciseProcessing: "exercise_processing",
  Exercised: "exercised",
  Expired: "expired",
  Refunded: "refunded"
};
function StateFromJSON(json) {
  return StateFromJSONTyped(json, false);
}
function StateFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function StateToJSON(value) {
  return value;
}

// src/models/CfarContract.ts
function instanceOfCfarContract(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "state" in value;
  isInstance = isInstance && "purchase_quote" in value;
  isInstance = isInstance && "partner_booking_id" in value;
  isInstance = isInstance && "booking_locators" in value;
  isInstance = isInstance && "created_date_time" in value;
  return isInstance;
}
function CfarContractFromJSON(json) {
  return CfarContractFromJSONTyped(json, false);
}
function CfarContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "state": StateFromJSON(json["state"]),
    "purchase_quote": CfarPurchaseQuoteFromJSON(json["purchase_quote"]),
    "partner_booking_id": json["partner_booking_id"],
    "booking_locators": json["booking_locators"],
    "created_date_time": new Date(json["created_date_time"]),
    "exercise": !exists(json, "exercise") ? void 0 : CfarExerciseFromJSON(json["exercise"]),
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"],
    "refund": !exists(json, "refund") ? void 0 : CfarRefundFromJSON(json["refund"])
  };
}
function CfarContractToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "state": StateToJSON(value.state),
    "purchase_quote": CfarPurchaseQuoteToJSON(value.purchase_quote),
    "partner_booking_id": value.partner_booking_id,
    "booking_locators": value.booking_locators,
    "created_date_time": value.created_date_time.toISOString(),
    "exercise": CfarExerciseToJSON(value.exercise),
    "ext_attributes": value.ext_attributes,
    "refund": CfarRefundToJSON(value.refund)
  };
}

// src/models/ContractNotFound.ts
function instanceOfContractNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFoundFromJSON(json) {
  return ContractNotFoundFromJSONTyped(json, false);
}
function ContractNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ContractNotFound1.ts
function instanceOfContractNotFound1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFound1FromJSON(json) {
  return ContractNotFound1FromJSONTyped(json, false);
}
function ContractNotFound1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFound1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ContractNotFound2.ts
function instanceOfContractNotFound2(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFound2FromJSON(json) {
  return ContractNotFound2FromJSONTyped(json, false);
}
function ContractNotFound2FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFound2ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ContractNotFound3.ts
function instanceOfContractNotFound3(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFound3FromJSON(json) {
  return ContractNotFound3FromJSONTyped(json, false);
}
function ContractNotFound3FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFound3ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ContractNotFound4.ts
function instanceOfContractNotFound4(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFound4FromJSON(json) {
  return ContractNotFound4FromJSONTyped(json, false);
}
function ContractNotFound4FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFound4ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ContractNotFound5.ts
function instanceOfContractNotFound5(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractNotFound5FromJSON(json) {
  return ContractNotFound5FromJSONTyped(json, false);
}
function ContractNotFound5FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractNotFound5ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ContractStateInvalid.ts
function instanceOfContractStateInvalid(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ContractStateInvalidFromJSON(json) {
  return ContractStateInvalidFromJSONTyped(json, false);
}
function ContractStateInvalidFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ContractStateInvalidToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidInitiatedDateTime.ts
function instanceOfInvalidInitiatedDateTime(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidInitiatedDateTimeFromJSON(json) {
  return InvalidInitiatedDateTimeFromJSONTyped(json, false);
}
function InvalidInitiatedDateTimeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidInitiatedDateTimeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CreateCfarExerciseError.ts
function CreateCfarExerciseErrorFromJSON(json) {
  return CreateCfarExerciseErrorFromJSONTyped(json, false);
}
function CreateCfarExerciseErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "cancel_booking_failed":
      return __spreadProps(__spreadValues({}, CancelBookingFailedFromJSONTyped(json, true)), { code: "cancel_booking_failed" });
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFound2FromJSONTyped(json, true)), { code: "contract_not_found" });
    case "contract_state_invalid":
      return __spreadProps(__spreadValues({}, ContractStateInvalidFromJSONTyped(json, true)), { code: "contract_state_invalid" });
    case "invalid_initiated_date_time":
      return __spreadProps(__spreadValues({}, InvalidInitiatedDateTimeFromJSONTyped(json, true)), { code: "invalid_initiated_date_time" });
    default:
      throw new Error(`No variant of CreateCfarExerciseError exists with 'code=${json["code"]}'`);
  }
}
function CreateCfarExerciseErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "cancel_booking_failed":
      return CancelBookingFailedToJSON(value);
    case "contract_not_found":
      return ContractNotFound2ToJSON(value);
    case "contract_state_invalid":
      return ContractStateInvalidToJSON(value);
    case "invalid_initiated_date_time":
      return InvalidInitiatedDateTimeToJSON(value);
    default:
      throw new Error(`No variant of CreateCfarExerciseError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CreateCfarExerciseRequest.ts
function instanceOfCreateCfarExerciseRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "contract_id" in value;
  return isInstance;
}
function CreateCfarExerciseRequestFromJSON(json) {
  return CreateCfarExerciseRequestFromJSONTyped(json, false);
}
function CreateCfarExerciseRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract_id": json["contract_id"],
    "ext_attributes": !exists(json, "ext_attributes") ? void 0 : json["ext_attributes"]
  };
}
function CreateCfarExerciseRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contract_id": value.contract_id,
    "ext_attributes": value.ext_attributes
  };
}

// src/models/EmailNotFound.ts
function instanceOfEmailNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function EmailNotFoundFromJSON(json) {
  return EmailNotFoundFromJSONTyped(json, false);
}
function EmailNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function EmailNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/PhoneNumberNotFound.ts
function instanceOfPhoneNumberNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function PhoneNumberNotFoundFromJSON(json) {
  return PhoneNumberNotFoundFromJSONTyped(json, false);
}
function PhoneNumberNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function PhoneNumberNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/SendVerificationCodeFailed.ts
function instanceOfSendVerificationCodeFailed(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function SendVerificationCodeFailedFromJSON(json) {
  return SendVerificationCodeFailedFromJSONTyped(json, false);
}
function SendVerificationCodeFailedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function SendVerificationCodeFailedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CreateLoginCodeError.ts
function CreateLoginCodeErrorFromJSON(json) {
  return CreateLoginCodeErrorFromJSONTyped(json, false);
}
function CreateLoginCodeErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFoundFromJSONTyped(json, true)), { code: "contract_not_found" });
    case "email_not_found":
      return __spreadProps(__spreadValues({}, EmailNotFoundFromJSONTyped(json, true)), { code: "email_not_found" });
    case "phone_number_not_found":
      return __spreadProps(__spreadValues({}, PhoneNumberNotFoundFromJSONTyped(json, true)), { code: "phone_number_not_found" });
    case "send_verification_code_failed":
      return __spreadProps(__spreadValues({}, SendVerificationCodeFailedFromJSONTyped(json, true)), { code: "send_verification_code_failed" });
    default:
      throw new Error(`No variant of CreateLoginCodeError exists with 'code=${json["code"]}'`);
  }
}
function CreateLoginCodeErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "contract_not_found":
      return ContractNotFoundToJSON(value);
    case "email_not_found":
      return EmailNotFoundToJSON(value);
    case "phone_number_not_found":
      return PhoneNumberNotFoundToJSON(value);
    case "send_verification_code_failed":
      return SendVerificationCodeFailedToJSON(value);
    default:
      throw new Error(`No variant of CreateLoginCodeError exists with 'code=${value["code"]}'`);
  }
}

// src/models/VerificationChannel.ts
var VerificationChannel = {
  Email: "email",
  Sms: "sms"
};
function VerificationChannelFromJSON(json) {
  return VerificationChannelFromJSONTyped(json, false);
}
function VerificationChannelFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function VerificationChannelToJSON(value) {
  return value;
}

// src/models/CreateLoginCodeRequest.ts
function instanceOfCreateLoginCodeRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "verification_channel" in value;
  return isInstance;
}
function CreateLoginCodeRequestFromJSON(json) {
  return CreateLoginCodeRequestFromJSONTyped(json, false);
}
function CreateLoginCodeRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract_id": json["contract_id"],
    "verification_channel": VerificationChannelFromJSON(json["verification_channel"])
  };
}
function CreateLoginCodeRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contract_id": value.contract_id,
    "verification_channel": VerificationChannelToJSON(value.verification_channel)
  };
}

// src/models/EmailNotFound1.ts
function instanceOfEmailNotFound1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function EmailNotFound1FromJSON(json) {
  return EmailNotFound1FromJSONTyped(json, false);
}
function EmailNotFound1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function EmailNotFound1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/PhoneNumberNotFound1.ts
function instanceOfPhoneNumberNotFound1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function PhoneNumberNotFound1FromJSON(json) {
  return PhoneNumberNotFound1FromJSONTyped(json, false);
}
function PhoneNumberNotFound1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function PhoneNumberNotFound1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/VerificationError.ts
function instanceOfVerificationError(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function VerificationErrorFromJSON(json) {
  return VerificationErrorFromJSONTyped(json, false);
}
function VerificationErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function VerificationErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CreateLoginSessionError.ts
function CreateLoginSessionErrorFromJSON(json) {
  return CreateLoginSessionErrorFromJSONTyped(json, false);
}
function CreateLoginSessionErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFound1FromJSONTyped(json, true)), { code: "contract_not_found" });
    case "email_not_found":
      return __spreadProps(__spreadValues({}, EmailNotFound1FromJSONTyped(json, true)), { code: "email_not_found" });
    case "phone_number_not_found":
      return __spreadProps(__spreadValues({}, PhoneNumberNotFound1FromJSONTyped(json, true)), { code: "phone_number_not_found" });
    case "verification_error":
      return __spreadProps(__spreadValues({}, VerificationErrorFromJSONTyped(json, true)), { code: "verification_error" });
    default:
      throw new Error(`No variant of CreateLoginSessionError exists with 'code=${json["code"]}'`);
  }
}
function CreateLoginSessionErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "contract_not_found":
      return ContractNotFound1ToJSON(value);
    case "email_not_found":
      return EmailNotFound1ToJSON(value);
    case "phone_number_not_found":
      return PhoneNumberNotFound1ToJSON(value);
    case "verification_error":
      return VerificationErrorToJSON(value);
    default:
      throw new Error(`No variant of CreateLoginSessionError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CreateLoginSessionRequest.ts
function instanceOfCreateLoginSessionRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "verification_code" in value;
  isInstance = isInstance && "verification_channel" in value;
  return isInstance;
}
function CreateLoginSessionRequestFromJSON(json) {
  return CreateLoginSessionRequestFromJSONTyped(json, false);
}
function CreateLoginSessionRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract_id": json["contract_id"],
    "verification_code": json["verification_code"],
    "verification_channel": VerificationChannelFromJSON(json["verification_channel"])
  };
}
function CreateLoginSessionRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contract_id": value.contract_id,
    "verification_code": value.verification_code,
    "verification_channel": VerificationChannelToJSON(value.verification_channel)
  };
}

// src/models/InvalidDateOfBirth1.ts
function instanceOfInvalidDateOfBirth1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidDateOfBirth1FromJSON(json) {
  return InvalidDateOfBirth1FromJSONTyped(json, false);
}
function InvalidDateOfBirth1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidDateOfBirth1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidFieldValue1.ts
function instanceOfInvalidFieldValue1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidFieldValue1FromJSON(json) {
  return InvalidFieldValue1FromJSONTyped(json, false);
}
function InvalidFieldValue1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidFieldValue1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidPostalCode1.ts
function instanceOfInvalidPostalCode1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidPostalCode1FromJSON(json) {
  return InvalidPostalCode1FromJSONTyped(json, false);
}
function InvalidPostalCode1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidPostalCode1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidStateProvince1.ts
function instanceOfInvalidStateProvince1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidStateProvince1FromJSON(json) {
  return InvalidStateProvince1FromJSONTyped(json, false);
}
function InvalidStateProvince1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidStateProvince1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/RefundAlreadySent1.ts
function instanceOfRefundAlreadySent1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function RefundAlreadySent1FromJSON(json) {
  return RefundAlreadySent1FromJSONTyped(json, false);
}
function RefundAlreadySent1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function RefundAlreadySent1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/Unknown1.ts
function instanceOfUnknown1(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function Unknown1FromJSON(json) {
  return Unknown1FromJSONTyped(json, false);
}
function Unknown1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function Unknown1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CreateRefundAuthenticationError.ts
function CreateRefundAuthenticationErrorFromJSON(json) {
  return CreateRefundAuthenticationErrorFromJSONTyped(json, false);
}
function CreateRefundAuthenticationErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFound4FromJSONTyped(json, true)), { code: "contract_not_found" });
    case "invalid_date_of_birth":
      return __spreadProps(__spreadValues({}, InvalidDateOfBirth1FromJSONTyped(json, true)), { code: "invalid_date_of_birth" });
    case "invalid_field_value":
      return __spreadProps(__spreadValues({}, InvalidFieldValue1FromJSONTyped(json, true)), { code: "invalid_field_value" });
    case "invalid_postal_code":
      return __spreadProps(__spreadValues({}, InvalidPostalCode1FromJSONTyped(json, true)), { code: "invalid_postal_code" });
    case "invalid_state_province":
      return __spreadProps(__spreadValues({}, InvalidStateProvince1FromJSONTyped(json, true)), { code: "invalid_state_province" });
    case "refund_already_sent":
      return __spreadProps(__spreadValues({}, RefundAlreadySent1FromJSONTyped(json, true)), { code: "refund_already_sent" });
    case "unknown":
      return __spreadProps(__spreadValues({}, Unknown1FromJSONTyped(json, true)), { code: "unknown" });
    default:
      throw new Error(`No variant of CreateRefundAuthenticationError exists with 'code=${json["code"]}'`);
  }
}
function CreateRefundAuthenticationErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "contract_not_found":
      return ContractNotFound4ToJSON(value);
    case "invalid_date_of_birth":
      return InvalidDateOfBirth1ToJSON(value);
    case "invalid_field_value":
      return InvalidFieldValue1ToJSON(value);
    case "invalid_postal_code":
      return InvalidPostalCode1ToJSON(value);
    case "invalid_state_province":
      return InvalidStateProvince1ToJSON(value);
    case "refund_already_sent":
      return RefundAlreadySent1ToJSON(value);
    case "unknown":
      return Unknown1ToJSON(value);
    default:
      throw new Error(`No variant of CreateRefundAuthenticationError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CreateRefundAuthenticationRequest.ts
function instanceOfCreateRefundAuthenticationRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "user_id" in value;
  return isInstance;
}
function CreateRefundAuthenticationRequestFromJSON(json) {
  return CreateRefundAuthenticationRequestFromJSONTyped(json, false);
}
function CreateRefundAuthenticationRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "user_id": json["user_id"]
  };
}
function CreateRefundAuthenticationRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.user_id
  };
}

// src/models/ExerciseAlreadyCompleted.ts
function instanceOfExerciseAlreadyCompleted(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ExerciseAlreadyCompletedFromJSON(json) {
  return ExerciseAlreadyCompletedFromJSONTyped(json, false);
}
function ExerciseAlreadyCompletedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ExerciseAlreadyCompletedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ExerciseAlreadyProcessing.ts
function instanceOfExerciseAlreadyProcessing(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ExerciseAlreadyProcessingFromJSON(json) {
  return ExerciseAlreadyProcessingFromJSONTyped(json, false);
}
function ExerciseAlreadyProcessingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ExerciseAlreadyProcessingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ExerciseFailed.ts
function instanceOfExerciseFailed(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ExerciseFailedFromJSON(json) {
  return ExerciseFailedFromJSONTyped(json, false);
}
function ExerciseFailedFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ExerciseFailedToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/ExerciseNotFound.ts
function instanceOfExerciseNotFound(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function ExerciseNotFoundFromJSON(json) {
  return ExerciseNotFoundFromJSONTyped(json, false);
}
function ExerciseNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function ExerciseNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/PaymentFailure.ts
function instanceOfPaymentFailure(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function PaymentFailureFromJSON(json) {
  return PaymentFailureFromJSONTyped(json, false);
}
function PaymentFailureFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function PaymentFailureToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CreateRefundError.ts
function CreateRefundErrorFromJSON(json) {
  return CreateRefundErrorFromJSONTyped(json, false);
}
function CreateRefundErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "booking_cancellation_not_found":
      return __spreadProps(__spreadValues({}, BookingCancellationNotFoundFromJSONTyped(json, true)), { code: "booking_cancellation_not_found" });
    case "cancel_booking_failure":
      return __spreadProps(__spreadValues({}, CancelBookingFailureFromJSONTyped(json, true)), { code: "cancel_booking_failure" });
    case "cancellation_already_processed":
      return __spreadProps(__spreadValues({}, CancellationAlreadyProcessedFromJSONTyped(json, true)), { code: "cancellation_already_processed" });
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFound5FromJSONTyped(json, true)), { code: "contract_not_found" });
    case "exercise_already_completed":
      return __spreadProps(__spreadValues({}, ExerciseAlreadyCompletedFromJSONTyped(json, true)), { code: "exercise_already_completed" });
    case "exercise_already_processing":
      return __spreadProps(__spreadValues({}, ExerciseAlreadyProcessingFromJSONTyped(json, true)), { code: "exercise_already_processing" });
    case "exercise_failed":
      return __spreadProps(__spreadValues({}, ExerciseFailedFromJSONTyped(json, true)), { code: "exercise_failed" });
    case "exercise_not_found":
      return __spreadProps(__spreadValues({}, ExerciseNotFoundFromJSONTyped(json, true)), { code: "exercise_not_found" });
    case "payment_failure":
      return __spreadProps(__spreadValues({}, PaymentFailureFromJSONTyped(json, true)), { code: "payment_failure" });
    default:
      throw new Error(`No variant of CreateRefundError exists with 'code=${json["code"]}'`);
  }
}
function CreateRefundErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "booking_cancellation_not_found":
      return BookingCancellationNotFoundToJSON(value);
    case "cancel_booking_failure":
      return CancelBookingFailureToJSON(value);
    case "cancellation_already_processed":
      return CancellationAlreadyProcessedToJSON(value);
    case "contract_not_found":
      return ContractNotFound5ToJSON(value);
    case "exercise_already_completed":
      return ExerciseAlreadyCompletedToJSON(value);
    case "exercise_already_processing":
      return ExerciseAlreadyProcessingToJSON(value);
    case "exercise_failed":
      return ExerciseFailedToJSON(value);
    case "exercise_not_found":
      return ExerciseNotFoundToJSON(value);
    case "payment_failure":
      return PaymentFailureToJSON(value);
    default:
      throw new Error(`No variant of CreateRefundError exists with 'code=${value["code"]}'`);
  }
}

// src/models/InvalidDateOfBirth.ts
function instanceOfInvalidDateOfBirth(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidDateOfBirthFromJSON(json) {
  return InvalidDateOfBirthFromJSONTyped(json, false);
}
function InvalidDateOfBirthFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidDateOfBirthToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidFieldValue.ts
function instanceOfInvalidFieldValue(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidFieldValueFromJSON(json) {
  return InvalidFieldValueFromJSONTyped(json, false);
}
function InvalidFieldValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidFieldValueToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidPostalCode.ts
function instanceOfInvalidPostalCode(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidPostalCodeFromJSON(json) {
  return InvalidPostalCodeFromJSONTyped(json, false);
}
function InvalidPostalCodeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidPostalCodeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/InvalidStateProvince.ts
function instanceOfInvalidStateProvince(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function InvalidStateProvinceFromJSON(json) {
  return InvalidStateProvinceFromJSONTyped(json, false);
}
function InvalidStateProvinceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function InvalidStateProvinceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/RefundAlreadySent.ts
function instanceOfRefundAlreadySent(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function RefundAlreadySentFromJSON(json) {
  return RefundAlreadySentFromJSONTyped(json, false);
}
function RefundAlreadySentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function RefundAlreadySentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/Unknown.ts
function instanceOfUnknown(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "code" in value;
  return isInstance;
}
function UnknownFromJSON(json) {
  return UnknownFromJSONTyped(json, false);
}
function UnknownFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "code": json["code"]
  };
}
function UnknownToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "code": value.code
  };
}

// src/models/CreateRefundRecipientError.ts
function CreateRefundRecipientErrorFromJSON(json) {
  return CreateRefundRecipientErrorFromJSONTyped(json, false);
}
function CreateRefundRecipientErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["code"]) {
    case "contract_not_found":
      return __spreadProps(__spreadValues({}, ContractNotFound3FromJSONTyped(json, true)), { code: "contract_not_found" });
    case "invalid_date_of_birth":
      return __spreadProps(__spreadValues({}, InvalidDateOfBirthFromJSONTyped(json, true)), { code: "invalid_date_of_birth" });
    case "invalid_field_value":
      return __spreadProps(__spreadValues({}, InvalidFieldValueFromJSONTyped(json, true)), { code: "invalid_field_value" });
    case "invalid_postal_code":
      return __spreadProps(__spreadValues({}, InvalidPostalCodeFromJSONTyped(json, true)), { code: "invalid_postal_code" });
    case "invalid_state_province":
      return __spreadProps(__spreadValues({}, InvalidStateProvinceFromJSONTyped(json, true)), { code: "invalid_state_province" });
    case "refund_already_sent":
      return __spreadProps(__spreadValues({}, RefundAlreadySentFromJSONTyped(json, true)), { code: "refund_already_sent" });
    case "unknown":
      return __spreadProps(__spreadValues({}, UnknownFromJSONTyped(json, true)), { code: "unknown" });
    default:
      throw new Error(`No variant of CreateRefundRecipientError exists with 'code=${json["code"]}'`);
  }
}
function CreateRefundRecipientErrorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["code"]) {
    case "contract_not_found":
      return ContractNotFound3ToJSON(value);
    case "invalid_date_of_birth":
      return InvalidDateOfBirthToJSON(value);
    case "invalid_field_value":
      return InvalidFieldValueToJSON(value);
    case "invalid_postal_code":
      return InvalidPostalCodeToJSON(value);
    case "invalid_state_province":
      return InvalidStateProvinceToJSON(value);
    case "refund_already_sent":
      return RefundAlreadySentToJSON(value);
    case "unknown":
      return UnknownToJSON(value);
    default:
      throw new Error(`No variant of CreateRefundRecipientError exists with 'code=${value["code"]}'`);
  }
}

// src/models/CreateRefundRecipientRequest.ts
function instanceOfCreateRefundRecipientRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "first_name" in value;
  isInstance = isInstance && "last_name" in value;
  isInstance = isInstance && "date_of_birth" in value;
  isInstance = isInstance && "address" in value;
  isInstance = isInstance && "city" in value;
  isInstance = isInstance && "state_province" in value;
  isInstance = isInstance && "country" in value;
  isInstance = isInstance && "postal_code" in value;
  return isInstance;
}
function CreateRefundRecipientRequestFromJSON(json) {
  return CreateRefundRecipientRequestFromJSONTyped(json, false);
}
function CreateRefundRecipientRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "first_name": json["first_name"],
    "last_name": json["last_name"],
    "date_of_birth": new Date(json["date_of_birth"]),
    "address": json["address"],
    "city": json["city"],
    "state_province": json["state_province"],
    "country": json["country"],
    "postal_code": json["postal_code"]
  };
}
function CreateRefundRecipientRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "first_name": value.first_name,
    "last_name": value.last_name,
    "date_of_birth": value.date_of_birth.toISOString().substring(0, 10),
    "address": value.address,
    "city": value.city,
    "state_province": value.state_province,
    "country": value.country,
    "postal_code": value.postal_code
  };
}

// src/models/CreateRefundRequest.ts
function instanceOfCreateRefundRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "contract_id" in value;
  isInstance = isInstance && "transfer_method_id" in value;
  return isInstance;
}
function CreateRefundRequestFromJSON(json) {
  return CreateRefundRequestFromJSONTyped(json, false);
}
function CreateRefundRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract_id": json["contract_id"],
    "transfer_method_id": json["transfer_method_id"]
  };
}
function CreateRefundRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contract_id": value.contract_id,
    "transfer_method_id": value.transfer_method_id
  };
}

// src/models/ExternalUserAuthorizationToken.ts
function instanceOfExternalUserAuthorizationToken(value) {
  let isInstance = true;
  isInstance = isInstance && "token" in value;
  return isInstance;
}
function ExternalUserAuthorizationTokenFromJSON(json) {
  return ExternalUserAuthorizationTokenFromJSONTyped(json, false);
}
function ExternalUserAuthorizationTokenFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"]
  };
}
function ExternalUserAuthorizationTokenToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token
  };
}

// src/models/RefundAuthentication.ts
function instanceOfRefundAuthentication(value) {
  let isInstance = true;
  isInstance = isInstance && "token" in value;
  return isInstance;
}
function RefundAuthenticationFromJSON(json) {
  return RefundAuthenticationFromJSONTyped(json, false);
}
function RefundAuthenticationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"]
  };
}
function RefundAuthenticationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token
  };
}

// src/models/RefundRecipient.ts
function instanceOfRefundRecipient(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function RefundRecipientFromJSON(json) {
  return RefundRecipientFromJSONTyped(json, false);
}
function RefundRecipientFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"]
  };
}
function RefundRecipientToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id
  };
}

// src/apis/AuthorizationApi.ts
var AuthorizationApi = class extends BaseAPI {
  /**
   * Create a login code
   * Create a Login Code
   */
  postLoginCodesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postLoginCodes.");
      }
      if (requestParameters.createLoginCodeRequest === null || requestParameters.createLoginCodeRequest === void 0) {
        throw new RequiredError("createLoginCodeRequest", "Required parameter requestParameters.createLoginCodeRequest was null or undefined when calling postLoginCodes.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (requestParameters.hCPartnerID !== void 0 && requestParameters.hCPartnerID !== null) {
        headerParameters["HC-Partner-ID"] = String(requestParameters.hCPartnerID);
      }
      const response = yield this.request({
        path: `/login_codes`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateLoginCodeRequestToJSON(requestParameters.createLoginCodeRequest)
      }, initOverrides);
      return new VoidApiResponse(response);
    });
  }
  /**
   * Create a login code
   * Create a Login Code
   */
  postLoginCodes(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      yield this.postLoginCodesRaw(requestParameters, initOverrides);
    });
  }
  /**
   * Create a login session
   * Create a Login Session
   */
  postLoginSessionsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postLoginSessions.");
      }
      if (requestParameters.createLoginSessionRequest === null || requestParameters.createLoginSessionRequest === void 0) {
        throw new RequiredError("createLoginSessionRequest", "Required parameter requestParameters.createLoginSessionRequest was null or undefined when calling postLoginSessions.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (requestParameters.hCPartnerID !== void 0 && requestParameters.hCPartnerID !== null) {
        headerParameters["HC-Partner-ID"] = String(requestParameters.hCPartnerID);
      }
      const response = yield this.request({
        path: `/login_sessions`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateLoginSessionRequestToJSON(requestParameters.createLoginSessionRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ExternalUserAuthorizationTokenFromJSON(jsonValue));
    });
  }
  /**
   * Create a login session
   * Create a Login Session
   */
  postLoginSessions(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postLoginSessionsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
};

// src/apis/CancelForAnyReasonCFARApi.ts
var CancelForAnyReasonCFARApi = class extends BaseAPI {
  /**
   * Get a CFAR contract
   * Get a CFAR Contract
   */
  getCfarContractsIdRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling getCfarContractsId.");
      }
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getCfarContractsId.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (requestParameters.hCPartnerID !== void 0 && requestParameters.hCPartnerID !== null) {
        headerParameters["HC-Partner-ID"] = String(requestParameters.hCPartnerID);
      }
      if (this.configuration && this.configuration.accessToken) {
        const token = this.configuration.accessToken;
        const tokenString = yield token("httpAuth", []);
        if (tokenString) {
          headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
      }
      const response = yield this.request({
        path: `/cfar_contracts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarContractFromJSON(jsonValue));
    });
  }
  /**
   * Get a CFAR contract
   * Get a CFAR Contract
   */
  getCfarContractsId(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCfarContractsIdRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Record that a request to exercise a CFAR contract has occurred
   * Create an Exercise Request
   */
  postCfarExercisesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postCfarExercises.");
      }
      if (requestParameters.createCfarExerciseRequest === null || requestParameters.createCfarExerciseRequest === void 0) {
        throw new RequiredError("createCfarExerciseRequest", "Required parameter requestParameters.createCfarExerciseRequest was null or undefined when calling postCfarExercises.");
      }
      const queryParameters = {};
      if (requestParameters.validateOnly !== void 0) {
        queryParameters["validate_only"] = requestParameters.validateOnly;
      }
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (requestParameters.hCPartnerID !== void 0 && requestParameters.hCPartnerID !== null) {
        headerParameters["HC-Partner-ID"] = String(requestParameters.hCPartnerID);
      }
      if (this.configuration && this.configuration.accessToken) {
        const token = this.configuration.accessToken;
        const tokenString = yield token("httpAuth", []);
        if (tokenString) {
          headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
      }
      const response = yield this.request({
        path: `/cfar_exercises`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCfarExerciseRequestToJSON(requestParameters.createCfarExerciseRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CfarExerciseFromJSON(jsonValue));
    });
  }
  /**
   * Record that a request to exercise a CFAR contract has occurred
   * Create an Exercise Request
   */
  postCfarExercises(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postCfarExercisesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create a Refund Authentication Token
   * Create a Refund Authentication Token
   */
  postRefundAuthenticationsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postRefundAuthentications.");
      }
      if (requestParameters.createRefundAuthenticationRequest === null || requestParameters.createRefundAuthenticationRequest === void 0) {
        throw new RequiredError("createRefundAuthenticationRequest", "Required parameter requestParameters.createRefundAuthenticationRequest was null or undefined when calling postRefundAuthentications.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (requestParameters.hCPartnerID !== void 0 && requestParameters.hCPartnerID !== null) {
        headerParameters["HC-Partner-ID"] = String(requestParameters.hCPartnerID);
      }
      if (this.configuration && this.configuration.accessToken) {
        const token = this.configuration.accessToken;
        const tokenString = yield token("httpAuth", []);
        if (tokenString) {
          headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
      }
      const response = yield this.request({
        path: `/refund_authentications`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateRefundAuthenticationRequestToJSON(requestParameters.createRefundAuthenticationRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => RefundAuthenticationFromJSON(jsonValue));
    });
  }
  /**
   * Create a Refund Authentication Token
   * Create a Refund Authentication Token
   */
  postRefundAuthentications(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postRefundAuthenticationsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create a Refund Recipient
   * Create a Refund Recipient
   */
  postRefundRecipientsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postRefundRecipients.");
      }
      if (requestParameters.createRefundRecipientRequest === null || requestParameters.createRefundRecipientRequest === void 0) {
        throw new RequiredError("createRefundRecipientRequest", "Required parameter requestParameters.createRefundRecipientRequest was null or undefined when calling postRefundRecipients.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (requestParameters.hCPartnerID !== void 0 && requestParameters.hCPartnerID !== null) {
        headerParameters["HC-Partner-ID"] = String(requestParameters.hCPartnerID);
      }
      if (this.configuration && this.configuration.accessToken) {
        const token = this.configuration.accessToken;
        const tokenString = yield token("httpAuth", []);
        if (tokenString) {
          headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
      }
      const response = yield this.request({
        path: `/refund_recipients`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateRefundRecipientRequestToJSON(requestParameters.createRefundRecipientRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => RefundRecipientFromJSON(jsonValue));
    });
  }
  /**
   * Create a Refund Recipient
   * Create a Refund Recipient
   */
  postRefundRecipients(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.postRefundRecipientsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create a Refund
   * Create a Refund
   */
  postRefundsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === void 0) {
        throw new RequiredError("hCSessionID", "Required parameter requestParameters.hCSessionID was null or undefined when calling postRefunds.");
      }
      if (requestParameters.createRefundRequest === null || requestParameters.createRefundRequest === void 0) {
        throw new RequiredError("createRefundRequest", "Required parameter requestParameters.createRefundRequest was null or undefined when calling postRefunds.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (requestParameters.hCSessionID !== void 0 && requestParameters.hCSessionID !== null) {
        headerParameters["HC-Session-ID"] = String(requestParameters.hCSessionID);
      }
      if (requestParameters.hCPartnerID !== void 0 && requestParameters.hCPartnerID !== null) {
        headerParameters["HC-Partner-ID"] = String(requestParameters.hCPartnerID);
      }
      if (this.configuration && this.configuration.accessToken) {
        const token = this.configuration.accessToken;
        const tokenString = yield token("httpAuth", []);
        if (tokenString) {
          headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
      }
      const response = yield this.request({
        path: `/refunds`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateRefundRequestToJSON(requestParameters.createRefundRequest)
      }, initOverrides);
      return new VoidApiResponse(response);
    });
  }
  /**
   * Create a Refund
   * Create a Refund
   */
  postRefunds(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      yield this.postRefundsRaw(requestParameters, initOverrides);
    });
  }
};
export {
  AncillaryFromJSON,
  AncillaryFromJSONTyped,
  AncillaryToJSON,
  AuthorizationApi,
  BASE_PATH,
  BadRequestFromJSON,
  BadRequestFromJSONTyped,
  BadRequestToJSON,
  BaseAPI,
  BlobApiResponse,
  BookingCancellationNotFoundFromJSON,
  BookingCancellationNotFoundFromJSONTyped,
  BookingCancellationNotFoundToJSON,
  COLLECTION_FORMATS,
  CancelBookingFailedFromJSON,
  CancelBookingFailedFromJSONTyped,
  CancelBookingFailedToJSON,
  CancelBookingFailureFromJSON,
  CancelBookingFailureFromJSONTyped,
  CancelBookingFailureToJSON,
  CancelForAnyReasonCFARApi,
  CancellationAlreadyProcessedFromJSON,
  CancellationAlreadyProcessedFromJSONTyped,
  CancellationAlreadyProcessedToJSON,
  CancellationMethod,
  CancellationMethodFromJSON,
  CancellationMethodFromJSONTyped,
  CancellationMethodToJSON,
  CancellationSource,
  CancellationSourceFromJSON,
  CancellationSourceFromJSONTyped,
  CancellationSourceToJSON,
  CfarContractFromJSON,
  CfarContractFromJSONTyped,
  CfarContractToJSON,
  CfarExerciseFromJSON,
  CfarExerciseFromJSONTyped,
  CfarExerciseToJSON,
  CfarFareFromJSON,
  CfarFareFromJSONTyped,
  CfarFareSliceFromJSON,
  CfarFareSliceFromJSONTyped,
  CfarFareSliceSegmentFromJSON,
  CfarFareSliceSegmentFromJSONTyped,
  CfarFareSliceSegmentToJSON,
  CfarFareSliceToJSON,
  CfarFareToJSON,
  CfarOfferFromJSON,
  CfarOfferFromJSONTyped,
  CfarOfferToJSON,
  CfarPartnerBookingCancellationFromJSON,
  CfarPartnerBookingCancellationFromJSONTyped,
  CfarPartnerBookingCancellationToJSON,
  CfarPurchaseOptionFromJSON,
  CfarPurchaseOptionFromJSONTyped,
  CfarPurchaseOptionToJSON,
  CfarPurchaseQuoteFromJSON,
  CfarPurchaseQuoteFromJSONTyped,
  CfarPurchaseQuoteToJSON,
  CfarRefundFromJSON,
  CfarRefundFromJSONTyped,
  CfarRefundReasonFromJSON,
  CfarRefundReasonFromJSONTyped,
  CfarRefundReasonToJSON,
  CfarRefundToJSON,
  CompletedFromJSON,
  CompletedFromJSONTyped,
  CompletedToJSON,
  Configuration,
  ContractNotFound1FromJSON,
  ContractNotFound1FromJSONTyped,
  ContractNotFound1ToJSON,
  ContractNotFound2FromJSON,
  ContractNotFound2FromJSONTyped,
  ContractNotFound2ToJSON,
  ContractNotFound3FromJSON,
  ContractNotFound3FromJSONTyped,
  ContractNotFound3ToJSON,
  ContractNotFound4FromJSON,
  ContractNotFound4FromJSONTyped,
  ContractNotFound4ToJSON,
  ContractNotFound5FromJSON,
  ContractNotFound5FromJSONTyped,
  ContractNotFound5ToJSON,
  ContractNotFoundFromJSON,
  ContractNotFoundFromJSONTyped,
  ContractNotFoundToJSON,
  ContractStateInvalidFromJSON,
  ContractStateInvalidFromJSONTyped,
  ContractStateInvalidToJSON,
  CreateCfarExerciseErrorFromJSON,
  CreateCfarExerciseErrorFromJSONTyped,
  CreateCfarExerciseErrorToJSON,
  CreateCfarExerciseRequestFromJSON,
  CreateCfarExerciseRequestFromJSONTyped,
  CreateCfarExerciseRequestToJSON,
  CreateLoginCodeErrorFromJSON,
  CreateLoginCodeErrorFromJSONTyped,
  CreateLoginCodeErrorToJSON,
  CreateLoginCodeRequestFromJSON,
  CreateLoginCodeRequestFromJSONTyped,
  CreateLoginCodeRequestToJSON,
  CreateLoginSessionErrorFromJSON,
  CreateLoginSessionErrorFromJSONTyped,
  CreateLoginSessionErrorToJSON,
  CreateLoginSessionRequestFromJSON,
  CreateLoginSessionRequestFromJSONTyped,
  CreateLoginSessionRequestToJSON,
  CreateRefundAuthenticationErrorFromJSON,
  CreateRefundAuthenticationErrorFromJSONTyped,
  CreateRefundAuthenticationErrorToJSON,
  CreateRefundAuthenticationRequestFromJSON,
  CreateRefundAuthenticationRequestFromJSONTyped,
  CreateRefundAuthenticationRequestToJSON,
  CreateRefundErrorFromJSON,
  CreateRefundErrorFromJSONTyped,
  CreateRefundErrorToJSON,
  CreateRefundRecipientErrorFromJSON,
  CreateRefundRecipientErrorFromJSONTyped,
  CreateRefundRecipientErrorToJSON,
  CreateRefundRecipientRequestFromJSON,
  CreateRefundRecipientRequestFromJSONTyped,
  CreateRefundRecipientRequestToJSON,
  CreateRefundRequestFromJSON,
  CreateRefundRequestFromJSONTyped,
  CreateRefundRequestToJSON,
  DefaultConfig,
  EmailNotFound1FromJSON,
  EmailNotFound1FromJSONTyped,
  EmailNotFound1ToJSON,
  EmailNotFoundFromJSON,
  EmailNotFoundFromJSONTyped,
  EmailNotFoundToJSON,
  ExerciseAlreadyCompletedFromJSON,
  ExerciseAlreadyCompletedFromJSONTyped,
  ExerciseAlreadyCompletedToJSON,
  ExerciseAlreadyProcessingFromJSON,
  ExerciseAlreadyProcessingFromJSONTyped,
  ExerciseAlreadyProcessingToJSON,
  ExerciseFailedFromJSON,
  ExerciseFailedFromJSONTyped,
  ExerciseFailedToJSON,
  ExerciseNotFoundFromJSON,
  ExerciseNotFoundFromJSONTyped,
  ExerciseNotFoundToJSON,
  ExternalUserAuthorizationTokenFromJSON,
  ExternalUserAuthorizationTokenFromJSONTyped,
  ExternalUserAuthorizationTokenToJSON,
  FailedFromJSON,
  FailedFromJSONTyped,
  FailedToJSON,
  FareClass,
  FareClassFromJSON,
  FareClassFromJSONTyped,
  FareClassToJSON,
  FetchError,
  InvalidDateOfBirth1FromJSON,
  InvalidDateOfBirth1FromJSONTyped,
  InvalidDateOfBirth1ToJSON,
  InvalidDateOfBirthFromJSON,
  InvalidDateOfBirthFromJSONTyped,
  InvalidDateOfBirthToJSON,
  InvalidFieldValue1FromJSON,
  InvalidFieldValue1FromJSONTyped,
  InvalidFieldValue1ToJSON,
  InvalidFieldValueFromJSON,
  InvalidFieldValueFromJSONTyped,
  InvalidFieldValueToJSON,
  InvalidInitiatedDateTimeFromJSON,
  InvalidInitiatedDateTimeFromJSONTyped,
  InvalidInitiatedDateTimeToJSON,
  InvalidPostalCode1FromJSON,
  InvalidPostalCode1FromJSONTyped,
  InvalidPostalCode1ToJSON,
  InvalidPostalCodeFromJSON,
  InvalidPostalCodeFromJSONTyped,
  InvalidPostalCodeToJSON,
  InvalidStateProvince1FromJSON,
  InvalidStateProvince1FromJSONTyped,
  InvalidStateProvince1ToJSON,
  InvalidStateProvinceFromJSON,
  InvalidStateProvinceFromJSONTyped,
  InvalidStateProvinceToJSON,
  JSONApiResponse,
  LuggageFromJSON,
  LuggageFromJSONTyped,
  LuggageToJSON,
  ModelErrorFromJSON,
  ModelErrorFromJSONTyped,
  ModelErrorToJSON,
  OtherFromJSON,
  OtherFromJSONTyped,
  OtherToJSON,
  PartnerBookingCancellationStatusFromJSON,
  PartnerBookingCancellationStatusFromJSONTyped,
  PartnerBookingCancellationStatusToJSON,
  PassengerFromJSON,
  PassengerFromJSONTyped,
  PassengerToJSON,
  PassengerType,
  PassengerTypeFromJSON,
  PassengerTypeFromJSONTyped,
  PassengerTypeToJSON,
  PaymentFailureFromJSON,
  PaymentFailureFromJSONTyped,
  PaymentFailureToJSON,
  PhoneNumberNotFound1FromJSON,
  PhoneNumberNotFound1FromJSONTyped,
  PhoneNumberNotFound1ToJSON,
  PhoneNumberNotFoundFromJSON,
  PhoneNumberNotFoundFromJSONTyped,
  PhoneNumberNotFoundToJSON,
  ProcessingFromJSON,
  ProcessingFromJSONTyped,
  ProcessingToJSON,
  RefundAlreadySent1FromJSON,
  RefundAlreadySent1FromJSONTyped,
  RefundAlreadySent1ToJSON,
  RefundAlreadySentFromJSON,
  RefundAlreadySentFromJSONTyped,
  RefundAlreadySentToJSON,
  RefundAuthenticationFromJSON,
  RefundAuthenticationFromJSONTyped,
  RefundAuthenticationToJSON,
  RefundRecipientFromJSON,
  RefundRecipientFromJSONTyped,
  RefundRecipientToJSON,
  RequiredError,
  ResponseError,
  SeatSelectionFromJSON,
  SeatSelectionFromJSONTyped,
  SeatSelectionToJSON,
  SendVerificationCodeFailedFromJSON,
  SendVerificationCodeFailedFromJSONTyped,
  SendVerificationCodeFailedToJSON,
  State,
  StateFromJSON,
  StateFromJSONTyped,
  StateToJSON,
  TextApiResponse,
  TicketingFailureFromJSON,
  TicketingFailureFromJSONTyped,
  TicketingFailureToJSON,
  TravelInsuranceFromJSON,
  TravelInsuranceFromJSONTyped,
  TravelInsuranceToJSON,
  UnclassifiedFromJSON,
  UnclassifiedFromJSONTyped,
  UnclassifiedToJSON,
  Unknown1FromJSON,
  Unknown1FromJSONTyped,
  Unknown1ToJSON,
  UnknownFromJSON,
  UnknownFromJSONTyped,
  UnknownToJSON,
  VerificationChannel,
  VerificationChannelFromJSON,
  VerificationChannelFromJSONTyped,
  VerificationChannelToJSON,
  VerificationErrorFromJSON,
  VerificationErrorFromJSONTyped,
  VerificationErrorToJSON,
  VoidApiResponse,
  VoidWindowFromJSON,
  VoidWindowFromJSONTyped,
  VoidWindowToJSON,
  canConsumeForm,
  exists,
  instanceOfBadRequest,
  instanceOfBookingCancellationNotFound,
  instanceOfCancelBookingFailed,
  instanceOfCancelBookingFailure,
  instanceOfCancellationAlreadyProcessed,
  instanceOfCfarContract,
  instanceOfCfarExercise,
  instanceOfCfarFare,
  instanceOfCfarFareSlice,
  instanceOfCfarFareSliceSegment,
  instanceOfCfarOffer,
  instanceOfCfarPartnerBookingCancellation,
  instanceOfCfarPurchaseOption,
  instanceOfCfarPurchaseQuote,
  instanceOfCfarRefund,
  instanceOfCompleted,
  instanceOfContractNotFound,
  instanceOfContractNotFound1,
  instanceOfContractNotFound2,
  instanceOfContractNotFound3,
  instanceOfContractNotFound4,
  instanceOfContractNotFound5,
  instanceOfContractStateInvalid,
  instanceOfCreateCfarExerciseRequest,
  instanceOfCreateLoginCodeRequest,
  instanceOfCreateLoginSessionRequest,
  instanceOfCreateRefundAuthenticationRequest,
  instanceOfCreateRefundRecipientRequest,
  instanceOfCreateRefundRequest,
  instanceOfEmailNotFound,
  instanceOfEmailNotFound1,
  instanceOfExerciseAlreadyCompleted,
  instanceOfExerciseAlreadyProcessing,
  instanceOfExerciseFailed,
  instanceOfExerciseNotFound,
  instanceOfExternalUserAuthorizationToken,
  instanceOfFailed,
  instanceOfInvalidDateOfBirth,
  instanceOfInvalidDateOfBirth1,
  instanceOfInvalidFieldValue,
  instanceOfInvalidFieldValue1,
  instanceOfInvalidInitiatedDateTime,
  instanceOfInvalidPostalCode,
  instanceOfInvalidPostalCode1,
  instanceOfInvalidStateProvince,
  instanceOfInvalidStateProvince1,
  instanceOfLuggage,
  instanceOfModelError,
  instanceOfOther,
  instanceOfPassenger,
  instanceOfPaymentFailure,
  instanceOfPhoneNumberNotFound,
  instanceOfPhoneNumberNotFound1,
  instanceOfProcessing,
  instanceOfRefundAlreadySent,
  instanceOfRefundAlreadySent1,
  instanceOfRefundAuthentication,
  instanceOfRefundRecipient,
  instanceOfSeatSelection,
  instanceOfSendVerificationCodeFailed,
  instanceOfTicketingFailure,
  instanceOfTravelInsurance,
  instanceOfUnclassified,
  instanceOfUnknown,
  instanceOfUnknown1,
  instanceOfVerificationError,
  instanceOfVoidWindow,
  mapValues,
  querystring
};
//# sourceMappingURL=index.mjs.map